export const RateIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='13'
    fill='none'
    viewBox='0 0 17 13'
  >
    <path
      stroke='#757575'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M8.15 4.296v-.73m0 5.105V9.4M6.887 8.15c.189.309.511.523.9.523h.8a1.023 1.023 0 0 0 .248-2.017l-1.367-.344a1.023 1.023 0 0 1 .248-2.017h.8c.39 0 .71.212.9.52m5.238 6.846a14.4 14.4 0 0 0-6.306.15l-.197.05a15.3 15.3 0 0 1-6.703.159l-.127-.026a.83.83 0 0 1-.67-.817V2.145c0-.526.48-.92.997-.818a14.4 14.4 0 0 0 6.305-.15l.395-.098a14.4 14.4 0 0 1 6.305-.15l.327.065c.39.078.67.42.67.817v9.033c0 .526-.48.92-.996.817'
    ></path>
  </svg>
);
